import type { FaireProductEntity } from "../../entity_types/product";

export const p_v42bpekr6b: FaireProductEntity = {
  token: "p_v42bpekr6b",
  type: "product",
  name: "Victoria Pineapple Juice - Emile Vergeois - Glass Bottle",
  brandToken: "b_puxke2dnj7",
  brandName: "Apricot & Honey Gourmet",
  imageUrl:
    "https://cdn.faire.com/fastly/f57ec39e609caafec78299910fbea533cde1a499bebb46d95e29358350ecd98e.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.85,
  description:
    "Discover the tropical delight of Victoria Pineapple Juice from Apricot & Honey Gourmet. Sourced from the lush plantations of Victoria, this juice is as pure as it gets. Each glass bottle captures the vibrant taste and nutrition of ripe pineapples. As a family-operated importer and distributor of French artisanal fine food, Apricot & Honey Gourmet prides itself in bringing unique, high-quality products like this to your table. Enjoy the gourmet taste of France with this refreshing pineapple juice.",
  tags: [],
  msrpDollars: 13.69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:27.474Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
